import {Button} from 'antd';
import {WarningFilled} from '@ant-design/icons';
import {useTranslation} from 'react-i18next';

export const RecordButton = (props) => {
  const {t} = useTranslation();

  return (
    <Button
      type="primary"
      danger
      block
      {...props}
    >
      <WarningFilled/>
      {t('interruption.widget.button.record')}
    </Button>
  );
};
